import React from 'react'

class WhyWileyRow extends React.Component{
    render(){
        return(
            <div className="row icons-container">
                {this.props.rowContent.map((chooseWileyBlock, i) => (
                    <div className={`col-xs-12 col-sm-6 col-md-6 col-lg-6 
                         ${i === 0 ? 'card-mobile-padding-firstrow' : 'card-mobile-padding-secondrow'}`} key={i}>
                        <div className="card choose-wiley-card">
                            <div dangerouslySetInnerHTML={{ __html: chooseWileyBlock.content}}/>
                        </div>
                    </div>
                ))}
            </div>
        )
    }
}
export default WhyWileyRow